import { Storage } from "@capacitor/storage";
import { ConfAccount } from "../../context/account/paramsAccount";

export const saveCredentials = async (data: any, conf: ConfAccount, setConf: React.Dispatch<React.SetStateAction<ConfAccount>>, idUser: string | null) => {
  try {
    if (data.user) {
      const existingUser = await Storage.get({ key: `user_${idUser}` });
      if (!existingUser.value || JSON.stringify(data) !== existingUser.value) {
        await Storage.set({ key: `user_${idUser}`, value: JSON.stringify(data.user) });
      }
    }
    await Storage.set({ key: "last_user", value: JSON.stringify(idUser) });
    // const ok = await Storage.get({ key: 'user' });
    // const storedUser = ok.value ? JSON.parse(ok.value) : null;
    // // Mise à jour de l'état en fusionnant les données
    // setConf((prevConf) => ({
    //   ...prevConf, // Conserve les anciennes données
    //   ...storedUser, // Ajoute ou écrase avec les nouvelles données
    // }));
    if (data.token) {
      const existingToken = await Storage.get({ key: `token_${idUser}` });
      if (!existingToken.value || JSON.stringify(data) !== existingToken.value) {
        await Storage.set({ key: `token_${idUser}`, value: (data.token) });
      }
    }
    if (data.conf) {
      const existingConf = await Storage.get({ key: `conf_${idUser}` });
      if (!existingConf.value || JSON.stringify(data) !== existingConf.value) {
        await Storage.set({ key: `conf_${idUser}`, value: JSON.stringify(data.conf) });
      }
    }
  } catch (error) {
    console.error('Error saving credentials:', error);
  }
};
export const saveModeHorsligne = async (combinedResults: any, type: string, conf: ConfAccount) => {
  try {
    Storage.set({ key: `${type}_${conf.user.user_code}`, value: JSON.stringify(combinedResults) });
  } catch (error) {
    console.error('Error saving credentials:', error);
  }
};
export const savePrestaHorsligne = async (combinedResults: any, type: string, conf: ConfAccount, setConf: React.Dispatch<React.SetStateAction<ConfAccount>>
) => {
  try {
    Storage.set({ key: `${type}_${conf.user.user_code}`, value: JSON.stringify(combinedResults) });
  } catch (error) {
    console.error('Error saving credentials:', error);
  }
};
